// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentControllerCreateEnrollmentResponse {
    static getAttributeTypeMap() {
        return EnrollmentControllerCreateEnrollmentResponse.attributeTypeMap;
    }
}
EnrollmentControllerCreateEnrollmentResponse.discriminator = undefined;
EnrollmentControllerCreateEnrollmentResponse.attributeTypeMap = [
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "group",
        "baseName": "group",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "maxBenefitAmount",
        "baseName": "maxBenefitAmount",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "reenrollmentEligibilityDate",
        "baseName": "reenrollmentEligibilityDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStatus",
        "baseName": "enrollmentStatus",
        "type": "HhsStatus"
    }
];
//# sourceMappingURL=enrollmentControllerCreateEnrollmentResponse.js.map